import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=da461564&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "@/sass/06_atoms/tag.scss?vue&type=style&index=0&id=da461564&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da461564",
  null
  
)

export default component.exports